import {ReactComponent as JpgIcon} from "./icons/JPG.svg"
import {ReactComponent as PngIcon} from "./icons/PNG.svg"
import {ReactComponent as PdfIcon} from "./icons/PDF.svg"

const icons = {
    jpg: <JpgIcon />,
    png: <PngIcon />,
    pdf: <PdfIcon />,
};

export default icons;
